/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1755
 */

var r = require(/* 1756 */"./1756")
var o = require(/* 962 */"../../1775/962")
module.exports = function (e, t) {
  return r(o(e), t)
}
